import React from 'react';
import './App.css';
import Markdown from './components/markdown/Markdown';

function App() {
  return (
    <div className='container'>
      <Markdown />
    </div>
  );
}

export default App;
